<template>
  <div class="page" id="create-project-step-2">
    <div class="container">
      <div class="page-navigation">
        <div class="row align-items-center">
          <div class="col-auto">
            <button class="button back-button tooltip" data-tooltip="Regresar" @click="goBack">
                            <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                            <path id="Color_Overlay" data-name="Color Overlay" d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z" transform="translate(-23 -48.001)" />
                            </svg>
            </button>
          </div>
          <div class="col">
            <div class="text-center">
              <h1 class="page-title">Fuentes de información</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section>
      <div class="container">
        <!-- <h1 class="section-title">Pasos</h1> -->
        <div class="steps">
          <div class="step active">
            <span>01</span>
          </div>
          <div class="step">
            <span>02</span>
          </div>
          <div class="step">
            <span>03</span>
          </div>
        </div>

        <tv-catalog></tv-catalog>

        <sn-catalog></sn-catalog>

        <button class="button fluid next-button" @click="() => {next()}">Siguiente</button>
      </div>
    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import tvCatalog from "@/components/busquedaAvanzada/tvCatalog.vue";
import snCatalog from "@/components/busquedaAvanzada/snCatalog.vue";
export default {
  name: "step1",
  components: {
    tvCatalog,
    snCatalog
  },
  data: () => ({
    nProyecto: ""
  }),

  methods: {
    findNext() {
      var json = this.$store.state.projectConfig.fi;
      var keytoFind = "key2";
      var index = Object.keys(json).indexOf(keytoFind);
      alert(index);
    },

    buscaSigPantalla() {},
    next() {
      this.$store.commit("clearfiSelect");
      this.$store.commit("fillArray");

      console.log("next");
      // let nextComp = this.findNext();
      this.$router.push({ path: "/busqueda/nueva/step1a" });
    },
    goBack(){
        this.$router.push({
          name: 'busquedas'
        }); 
    }
  },
  beforeMount() {
    console.log("BeforeStep1");
    //this.$store.commit("clearfiSelect");
    console.log(this.$store.state.projectConfig)
   
  }
};
</script>

<style lang="scss">
.fil1 {
  fill: #fefefe;
  fill-rule: nonzero;
}
.fil0 {
  fill: #00b99e;
  fill-rule: nonzero;
}
</style>
